import { render, staticRenderFns } from "./OurProducts.vue?vue&type=template&id=7458f60f&scoped=true&"
var script = {}
import style0 from "./OurProducts.vue?vue&type=style&index=0&id=7458f60f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7458f60f",
  null
  
)

export default component.exports